import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var EmitterRate = /*#__PURE__*/function () {
  function EmitterRate() {
    _classCallCheck(this, EmitterRate);
    this.quantity = 1;
    this.delay = 0.1;
  }
  _createClass(EmitterRate, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.quantity !== undefined) {
        this.quantity = setRangeValue(data.quantity);
      }
      if (data.delay !== undefined) {
        this.delay = setRangeValue(data.delay);
      }
    }
  }]);
  return EmitterRate;
}();